import styled, { css } from 'styled-components';

import { lineClamp } from '@xing-com/crate-utils-line-clamp';
import { mediaWideNavless } from '@xing-com/layout-tokens';
import { ProfileImage } from '@xing-com/profile-image';
import { Tag } from '@xing-com/tag';
import {
  scale130,
  scale110,
  scale080,
  scale060,
  scale020,
  scale040,
  scale030,
  scale000,
} from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

const linkStyle = css`
  color: inherit;
  text-decoration: none;
  z-index: 1;

  &::after {
    position: absolute;
    display: block;
    content: '';
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  &:link,
  &:visited {
    text-decoration: none;
  }
  &:active,
  &:hover {
    cursor: pointer;
    text-decoration: none;
  }
`;

const StyledLink = styled.a`
  ${linkStyle}
`;

const HeroWrapper = styled.div`
  margin: 0 ${scale080};
  max-width: 183px;
  max-height: 284px;
  overflow: hidden;
  overflow-wrap: normal;

  @media ${mediaWideNavless} {
    max-width: 240px;
    max-height: 364px;
  }
`;

const ContainerWrapper = styled.div<{ $backgroundImage: string }>`
  background-image: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.6) 0%,
      rgba(0, 0, 0, 0) 60%
    ),
    url(${(props) => props.$backgroundImage});
  background-position: center;
  background-size: cover;
  border-radius: ${scale130};
  display: flex;
  flex-direction: column;
  height: 244px;
  width: 183px;
  padding: 0;
  position: relative;

  @media ${mediaWideNavless} {
    height: 320px;
    width: 240px;
  }
`;

const TextContainer = styled.div`
  max-width: 100%;
  padding: ${scale110};
  margin-top: auto;
`;

const TextName = styled(BodyCopy)`
  line-height: 17px;
  margin-bottom: ${scale030};
  color: white;
  ${lineClamp(2)};
`;

const TextJobTitle = styled(BodyCopy)`
  margin-bottom: ${scale000};
  line-height: 17px;
  color: white;
  ${lineClamp(1)};
`;

const TextJobTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const JobTitleContainer = styled.div`
  display: flex;
  z-index: 99;
`;

const StyledProfileImage = styled(ProfileImage)`
  &&& {
    width: 32px;
    height: 32px;
    margin-right: ${scale040};

    & > * {
      width: 32px;
      height: 32px;
    }
  }
`;

const CompanyLink = styled.a`
  color: inherit;
  text-decoration: none;
  position: relative;
  z-index: 2;

  &:link,
  &:visited {
    text-decoration: none;
  }
  &:active,
  &:hover {
    cursor: pointer;
    text-decoration: none;
  }
`;

const TagsContainer = styled.div`
  margin-top: ${scale040};
  display: flex;
  flex-wrap: wrap;
  max-width: 183px;

  @media ${mediaWideNavless} {
    margin-top: ${scale060};
    max-width: 240px;
  }
`;

const StyledTag = styled(Tag)`
  &:not(:last-child) {
    margin-right: ${scale020};
  }
  max-width: 183px;
  margin-bottom: 20px;
  flex-shrink: 1;
  min-width: 0;
  overflow: hidden;

  @media ${mediaWideNavless} {
    max-width: 240px;
  }
`;

export const Styled = {
  HeroWrapper,
  ContainerWrapper,
  TextContainer,
  TextName,
  TextJobTitle,
  TextJobTitleContainer,
  JobTitleContainer,
  StyledProfileImage,
  CompanyLink,
  TagsContainer,
  StyledTag,
  StyledLink,
};
